import { isNull, isUndefined } from 'lodash';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import React, { useEffect } from 'react';

function AuthGate({ children }) {
  const location = useLocation();
  const navigate = useNavigate();

  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const user = useSelector((state) => state.auth.user);
  const selfLogout = useSelector((state) => state.auth.selfLogout);

  useEffect(() => {
    if (selfLogout) {
      sessionStorage.clear();
      navigate('/', { replace: true });
    }
  }, [selfLogout, navigate]);

  if (selfLogout) {
    return null;
  }

  if (
    (isLoggedIn === false || isUndefined(user) || isNull(user)) &&
    !selfLogout
  ) {
    return (
      <Navigate
        to="/login"
        state={{ from: `${location.pathname}${location.search}` }}
      />
    );
  }

  return <>{children}</>;
}

export default AuthGate;
